// Component
export default () => {
    const modals = document.querySelectorAll('.modal-sortegories')

    // If there's no team modal, return
    if (!modals)
        return

    const openModal = (el) => {
        const trigger = el.relatedTarget

        if (!trigger)
            return

        const iframeSrc = trigger.getAttribute('data-bs-sortegories')
        const iframe = el.target.querySelector('iframe')

        if (iframe && iframeSrc) {
            iframe.src = iframeSrc
            iframe.title = 'Sortegories sample'
        }
    }

    const closeModal = (el) => {
        const iframe = el.target.querySelector('iframe')

        if (iframe) {
            iframe.removeAttribute('src')
            iframe.removeAttribute('title')
        }
    }

    modals.forEach(modal => modal.addEventListener(
        'show.bs.modal',
        openModal.bind(this)
    ))

    modals.forEach(modal => modal.addEventListener(
        'hidden.bs.modal',
        closeModal.bind(this)
    ))
}
